<template>
  <div
    class="basic_wrap"
    style="position: relative;"
  >
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('moneybag.rechargeRecord') }}
      </div>
    </div>
    <div class="user_yw">
      <div>
        <p>{{ $t('moneybag.accountBalance') }}</p>
        <p>{{ utils_moneyMark() }} {{ funds.toFixed(0) }}</p>
      </div>
    </div>
    <!-- <div class="user_zrzc">
			<span @click="$router.push('/invest')">{{$t('moneybag.recharge')}}</span>
			<span @click="$router.push('/cash')">{{$t('moneybag.withdraw')}}</span>
		</div> -->
    <div class="detail_box">
      <van-empty
        v-if="listShow"
        :description="$t('item.noData')"
      />
      <div
        v-for="item in data"
        class="item"
      >
        <div class="de_wrap">
          <p class="tit">
            {{ $t('invest_qrcode.recharge') }}
            (<template v-if="item.status =='0'||item.status =='3'">
              {{ $t('invest_qrcode.submittedSuccessfully') }}
            </template>
            <template v-if="item.status =='1'">
              {{ $t('invest.success') }}
            </template>
            <template v-if="item.status =='2'">
              {{ $t('invest.failed') }}
            </template>)
          </p>
          <template v-if="item.memo!=null">
            <p class="time">
              {{ $t('cash.remark') }}:{{ item.memo }}
            </p>
          </template>
          <p class="time">
            {{ item.orderid }}
          </p>
          <p class="time">
            {{ item.time }}
          </p>
        </div>
        <div
          class="price"
          :class="item.status =='1'?'add':item.status =='2'?'del':''"
          v-html="utils_moneyMark()+parseInt(item.money)"
        />
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem);

    export default {
        name: "RechargeRecord",
        data() {
            return {
				lang:this.$i18n.locale||"zh_cn",
                data: [],
                list: {},
                account: 0,
                option: [],
                listShow:false,
                funds: 0,
                mymoney: 0,
                userName:''
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            Fetch('/user/funds',{
                reason_id: 1
            }).then(r => {
                this.option.push({
                    text: this.$t('moneybag.types'),
                    value: 0
                })
                
                this.mymoney = r.data.mymoney;
                this.funds = parseInt(r.data.money);
                this.userName = r.data.username;
            });
            Fetch('/user/recharge_search').then(r=>{
                this.showError(r.data.length);
                this.data = r.data;
            })
        },
        methods: {
            chooseType(val) {
                if(val == 0){
                    Fetch('/user/funds').then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }else{
                    Fetch('/user/funds',{
                        reason_id: val
                    }).then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }
            },
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            }
        }
    };
</script>

<style lang="less" scoped>
    .red_top_bg {
        height: 126px;
        background: #0063d2;
    }
	.user_yw{
        
        display: flex;
		text-align: center;
		width: 96%;
		position: absolute;
		top: 78px;
		background: #FFFFFF;
		left: 2%;
		border-radius: 5px;
		padding: 20px 0;
        div{
            width: 100%;
        }
		p:nth-child(1){
			font-size: 16px;
			color: #646566;
			margin-bottom: 20px;
		}
		p:nth-child(2){
			font-size: 20px;
			font-weight: bold;
		}
	}
	.user_zrzc{
		text-align: center;
		width: 96%;
		position: absolute;
		top: 173px;
		background: #FFFFFF;
		left: 2%;
		border-radius: 0 0 5px 5px;
		padding: 15px 0;
		display: flex;
		justify-content: space-between;
		text-align: center;
		span{
			width: 40%;
			background: #0063d2;
			color: #FFFFFF;
			margin: 0px 20px;
			padding: 12px 10px;
			border-radius: 5px;
		}
	}

    .detail_box {
        width: 96%;
		margin-left: 2%;
        background: rgba(255, 255, 255, 1);
        border-radius: 6px;
        padding: 0 8px;
        margin-top: 60px;
        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 8px;
            border-bottom: 1px solid #ECECEC;

            .de_wrap {
                flex: 2;

                .tit {
                    font-size: 12px;
                    color: rgba(0,0,0,.8);
                    line-height: 20px;
                    font-weight: bold;
                }

                .time {
                    font-size: 12px;
                    color: rgba(0,0,0,.8);
                    line-height: 17px;
                    margin-top: 10px;
                }
            }

            .price {
                flex: 1;
                font-size: 16px;
                line-height: 28px;
                font-weight: bold;
                text-align: right;
                color: #ccc;
                white-space: nowrap;
                &.add {
                    color: #f12211;
                }
                &.del {
                    color: #3FAF3E;
                }
            }
        }
    }

    .basic_wrap {
        min-height: 100vh;
        box-sizing: border-box;
        padding: 12px 18px 78px;
        background: #fbf9fc url(../images/ban5/g.png) no-repeat top center / 100% auto;
    }

    .red_top_bg {
        height: 30px;
        background: transparent;
    }

    .red_top_bg .big_tit {
        top: 5px;
        color: #111;
        font-size: 14px;
        line-height: 20px;
    }

    .red_top_bg .back_left {
        width: 24px;
        height: 24px;
        margin: 3px 0 0;
    }

    .user_yw {
        position: static;
        width: auto;
        margin: 12px 0 0;
        padding: 14px;
        border-radius: 10px;
        background: linear-gradient(100deg, #df4ab7 0%, #6d3bc4 100%);
        color: #fff;
    }

    .user_yw p:nth-child(1),
    .user_yw p:nth-child(2) {
        margin: 0;
        color: #fff;
        font-size: 12px;
        line-height: 20px;
    }

    .detail_box {
        width: auto;
        margin: 12px 0 0;
        padding: 0 14px;
        border-radius: 10px;
        box-shadow: none;
    }

    .detail_box .item {
        padding: 12px 0;
        border-color: #f0eaf1;
    }

    .detail_box .item .de_wrap .tit,
    .detail_box .item .de_wrap .time,
    .detail_box .item .price {
        font-size: 12px;
    }
</style>
